import { render, staticRenderFns } from "./LinkCompanySociedadDialog.vue?vue&type=template&id=1caa363d&scoped=true"
import script from "./LinkCompanySociedadDialog.vue?vue&type=script&lang=js"
export * from "./LinkCompanySociedadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa363d",
  null
  
)

export default component.exports